document.addEventListener('DOMContentLoaded', function () {
  const usps = document.querySelectorAll('.ed-usps');

  usps.forEach((usp, index) => {
    const swiperContainer = usp.querySelector('.usps-swiper');

    if (swiperContainer) {
      // Initialize a new Swiper instance for each collection
      new Swiper(swiperContainer, {
        loop: true,
        autoplay: true,
        slidesPerView: 1,
        breakpoints: {
          990: {
            autoplay: false,
            slidesPerView: 3,
          },
        },
      });
    }
  });
});